import {createTheme} from '@mui/material/styles';

const mainTheme = createTheme({
    palette: {
        primary: {
            main: '#fff',
        },
        secondary: {
            main: '#D36E4B', // Complementary yellow color
            dark: '#d05c34', // Complementary yellow color
        },
        background: {
            default: '#29362C',
            light: '#DDE0DF'
        },
    },
    typography: {
        fontFamily: "Merriweather",
        h1: {
            fontFamily: "Merriweather",
            fontSize: '2.2rem',
            fontWeight: 700,
            color: '#000000',
            letterSpacing: '2px',
        },
        h2: {
            fontFamily: "Merriweather",
            fontSize: '2rem',
            fontWeight: 600,
            color: '#000000',
            letterSpacing: '2px',
        },
        h4: {
            fontFamily: "Merriweather",
            color: '#fff',
            fontSize: '2rem',
            fontWeight: 600,
        },
        h4Black: {
            fontFamily: "Merriweather",
            fontSize: '2.1rem',
            fontWeight: 600,
            color: '#000000',
            variantMapping: 'h4',
            letterSpacing: '2px',
        },
        h5 : {
            fontFamily: 'Merriweather',
            fontSize: '2rem',
            '@media (min-width:600px)': {
                fontSize: '1.5rem',
            },
        },
        h5White : {
            fontFamily: 'Merriweather',
            color:'white',
            fontSize: '1.8rem',
            '@media (min-width:600px)': {
                fontSize: '1.4rem',
            },
        },
        h6 :{
            fontFamily: 'Merriweather',
        },
        h7 :{
            fontFamily: 'Merriweather',
        },
        body1: {
            fontFamily: "Merriweather",
            fontSize: '1rem',
            color: '#000000',
        },
        body2: {
            fontFamily: "Merriweather",
            // fontSize: '1rem',
            // color: '#000000',
        },
        subtitle1: {
            fontFamily: "Merriweather",

        },
        body1White: {
            fontFamily: "Merriweather",
            fontSize: '1rem',
            color: '#ffffff',
        },
        body2Black: {
            fontFamily: "Merriweather",
            fontSize: '20px',
            color: 'black',
        },
        button: {
            fontFamily: "Merriweather",
            textTransform: 'uppercase',
            fontWeight: 700,
            letterSpacing: '2px',
        },
        variantMapping: {
            h4Black: 'h4',
        },
    },
    components: {
        MuiAccordion: {
            styleOverrides: {
                root: {
                    // this works
                    '&.Mui-expanded': {
                        borderTop: '2px solid rgba(0, 0, 0, .125)',
                        marginTop: '0px',
                        marginBottom: '0px',
                    },
                },
            },
        },
    },
});

export default mainTheme;
